import { SETUP_OPTIONS } from '../MoversDeviceSetup/constants';

export const INSTALL_TYPE_TO_DEPLETION_MAP = {
  'Professional SetUp': SETUP_OPTIONS.PROFESSIONAL,
  'Self SetUp': SETUP_OPTIONS.SELF,
};

export const INSTALL_MOVERS_TYPE_TO_DEPLETION_MAP = {
  'Professional setup': SETUP_OPTIONS.PROFESSIONAL,
  'Self setup': SETUP_OPTIONS.SELF,
};

export const pickupGuideline= ' must pickup the order. Bring the government-issued ID and the card used to make the purchase'

export const editBillingURL = new URL('/digital/nsa/secure/ui/acct/profile/contactbilling/billingAddress', window.location.origin).toString();

export const selfSetupVideoPosterURL = 'https://ss7.vzw.com/is/image/VerizonWireless/Horizontal_Overview_Video_poster?wid=1000';
